// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchOrderBookFailure, FetchOrderBookRequestAction, fetchOrderBookSuccess } from './actions';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import { FETCH_ORDER_BOOK_REQUEST } from './constants';
import { sendError } from '../errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';

export function* stockOrderBookSaga(action: FetchOrderBookRequestAction) {
    try {
        const data = yield call(() => api.get(`${appUrls.tradeURL}/order-book/${action.payload}`));
        if (data) {
            yield put(fetchOrderBookSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchOrderBookFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootStockOrderBookSaga(): Generator {
    yield takeLatest(FETCH_ORDER_BOOK_REQUEST, stockOrderBookSaga);
}
